<script setup lang="ts">
    /**
     * this is a wrapper around vuetify `VRadioGroup`.
     *
     * @see https://vuetifyjs.com/en/api/v-radio-group/ for list of available props
     */
    export interface VRadioGroupProps {
        hideDetails?: boolean;
        inline?: boolean;
        disabled?: boolean;
        modelValue: string | null;
        errorMessages?: string;
    }

    defineProps<VRadioGroupProps>();
</script>

<template>
    <v-radio-group
        :model-value="modelValue"
        class="app-radio-group"
        :hide-details="hideDetails"
        :inline="inline"
        :disabled="disabled"
        :error-messages="errorMessages"
        @update:model-value="$emit('update:modelValue', $event)"
    >
        <slot></slot>
    </v-radio-group>
</template>

<style scoped lang="scss">
    :deep(label) {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: normal;
        padding: 0;
    }

    :deep(i.mdi-radiobox-marked) {
        color: rgb(var(--v-theme-primary));
    }
</style>
